import React, { useContext, useState } from 'react';
import { GenericButton } from '../../fields/GenericButton';
import { ApplicationActionsContext } from '../../data/ApplicationDataSource';
import { FormValidationContext } from "../../../context/FormValidationProvider";
import { RedoOutlined } from '@ant-design/icons';

export function RecalculateButton({ value, defaultValue, ...props }) {
  const { isValid } = useContext(FormValidationContext);
  const actions = useContext(ApplicationActionsContext);
  return (
    <GenericButton
      icon={<RedoOutlined />}
      label='Recalculate'
      onClick={() => actions.saveApplication()}
      type='primary'
      disabled={!isValid}
    />
  );
}
